module.exports = __webpack_public_path__ + "static/media/leads vendidos slice.67fd0cfe.png";